import axios from 'axios';
import CONFIG from './CONFIG';

const useApiService = () => {
  const apiAddress = CONFIG.SERVER;

  const request = async (endpoint, method = 'GET', body = null, config = {}) => {
    try {
      const url = `${apiAddress}${endpoint}`;
      const options = {
        method,
        url,
        headers: {
          'Content-Type': 'application/json',
        },
        data: body ? JSON.stringify(body) : null,
        ...config,
      };
      const response = await axios(options);
      if (response.data.error) {
        console.error('⚠️ API Error:', response.data.error);
        return null;
      }
      return response.data; //  JSON
    } catch (error) {
      console.error('🚨 API request failed:', error);
      return null;
    }
  };
  const get = async (endpoint) => request(endpoint, 'GET');
  const post = async (endpoint, body, config) => request(endpoint, 'POST', body, config);

  return { get, post };
};

export default useApiService;
